import angular from 'angular';
import AboutCtrl from './aboutController'
import ConstructionSiteSupervisorsController from './constructionSiteSupervisorsController'
import ContractsController from './contractsController'
import DetailsController from './detailsController'
import EmailController from './emailController'
import FavoriteFiltersController from './favoriteFiltersController'
import FilterController from './filterController'
import FloatingBoxController from './floatingBoxController'
import LayersConfiguratorController from './layersConfiguratorController'
import LegendController from './legendController'
import MapController from './mapController'
import VideoController from './videoController'
import ObrasGovMapController from './obrasGovMapController'
import SearchController from './searchController'
import AlbumPhotosController from './albumPhotosController'
import AlbumPhotosDetailsController from './albumPhotosDetailsController'
import EdictController from './edictController'
import LicensesEnvironmentalController from './licensesEnvironmentalController'
import MODULE_NAME from '../../app'

angular.module(MODULE_NAME)
.controller('AboutController', AboutCtrl)
.controller('ConstructionSiteSupervisorsController', ConstructionSiteSupervisorsController)
.controller('ContractsController', ContractsController)
.controller('DetailsController', DetailsController)
.controller('EmailController', EmailController)
.controller('FavoriteFiltersController', FavoriteFiltersController)
.controller('FilterController', FilterController)
.controller('FloatingBoxController', FloatingBoxController)
.controller('LayersConfiguratorController', LayersConfiguratorController)
.controller('LegendController', LegendController)
.controller('MapController', MapController)
.controller('VideoController', VideoController)
.controller('ObrasGovMapController', ObrasGovMapController)
.controller('SearchController', SearchController)
.controller('AlbumPhotosController', AlbumPhotosController)
.controller('AlbumPhotosDetailsController', AlbumPhotosDetailsController)
.controller('EdictController', EdictController)
.controller('LicensesEnvironmentalController', LicensesEnvironmentalController)



// WEBPACK FOOTER //
// ./src/app/scripts/controllers/index.js